import React, { FunctionComponent, useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router"

import PureImage from "../../components/Image/PureImage"
import { loginUser } from "../../store/user/actions"
import { UserLoginParams } from "../../store/user/types"
import { useSelector, PromiseDispatch } from "../../store"
import { Link } from "react-router-dom"

import s from "./Login.less"
import DotButton from "../../components/Buttons/DotButton"

interface iLoginProps {
  loginUser: (x: UserLoginParams) => Promise<void>
}

const Login: FunctionComponent<iLoginProps> = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [response, setResponse] = useState("")
  const [isLoading, setLoading] = useState(false)
  const dispatch = useDispatch<PromiseDispatch<void>>()
  const history = useHistory()
  const redirection = useSelector(({ redirection }) => redirection)

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault()
    setLoading(true)
    dispatch(loginUser({ email, password }))
      .then(() => {
        setLoading(false)
        history.push(
          redirection && redirection !== "/login" ? redirection : "/",
        )
      })
      .catch((err) => {
        setLoading(false)
        setResponse(err?.data?.reason || "No response from server.")
        setTimeout(() => {
          setResponse("")
        }, 7000)
      })
  }
  return (
    <div className={s.loginContainer}>
      <div className={s.loginBox}>
        <div className={s.loginLogo}>
          <PureImage src="/logos/vr_all_art_logo.svg" />
        </div>
        <div className={s.headline}>
          <h1>Welcome to VR-All-Art</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            className={`input-bordered ${s.inputLogin}`}
            name="email"
            type="email"
            placeholder="E-mail"
            onChange={(e) => {
              setEmail(e.target.value)
            }}
          />
          <input
            className={`input-bordered ${s.inputLogin}`}
            name="password"
            type="password"
            placeholder="Password"
            onChange={(e) => {
              setPassword(e.target.value)
            }}
          />
          <div className={s.flexInputWrap}>
            <div className={s.checkboxWrap}>
              <input id="rembember" name="rembember" type="checkbox" />
              <label htmlFor="rembember">Remember me</label>
            </div>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
          <DotButton isLoading={isLoading} text="Login" />
        </form>
        <div className={s.response}>{response}</div>
      </div>
    </div>
  )
}

export default Login
